import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Box, Grid, Typography } from "@mui/material";

const CheckList = ({ title, description }) => {
    return(
        <Box sx={{mt:2}}>
            <Grid container spacing={3} alignItems={'center'}>
                <Grid item xs={12} sm={12} md={3} lg={2} xl={2} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Avatar sx={{ bgcolor: '#ebeef6', width: 40, height: 40 }}>
                        <FontAwesomeIcon icon={faCheck} color={'#147ac2'} style={{fontSize:20}}/>
                    </Avatar>
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={10} xl={10}>
                    <Typography variant='h6' component={'h1'} color={'primary.main'} fontWeight={'bold'}>
                        {title}
                    </Typography>
                    <Typography variant='h6' component={'h1'} color={'#5A5A5A'}>
                        {description}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
}

export default CheckList;